import * as Scrivito from "scrivito";
import HeadlineWidget from "../../Widgets/HeadlineWidget/HeadlineWidgetClass";
import {
  defaultPageInitialContent,
  defaultPageProperties,
} from "../_defaultPageEditingConfig";
import TRAINING_CATEGORIES from "./_trainingCategories";

const categoryLabels = TRAINING_CATEGORIES.map((c) => ({
  value: c.key,
  title: c.label.en,
}));

Scrivito.provideEditingConfig("TrainingCoursePage", {
  title: "Weiterbildungskurs",
  attributes: {
    title: { title: "Title" },
    image: { title: "Image" },
    description: { title: "Description" },
    format: {
      title: "Format",
      values: [
        { value: "online", title: "Online" },
        { value: "presence", title: "Presence" },
      ],
    },
    category: {
      title: "Category",
      values: categoryLabels,
    },
    provider: { title: "Provider" },
    location: { title: "Location" },
    startDate: { title: "Start Date" },
    endDate: { title: "End Date" },
    isFullyBooked: { title: "Fully Booked" },
    speaker: { title: "Speaker" },
    transferSupport: { title: "Transfer Support" },
    contactEmail: { title: "Registration E-Mail" },
    body: { title: "Content" },
  },
  properties: [...defaultPageProperties],
  propertiesGroups: [
    {
      title: "Kursdetails",
      properties: [
        "image",
        "format",
        "category",
        "provider",
        "location",
        "startDate",
        "endDate",
        "isFullyBooked",
        "speaker",
        "transferSupport",
        "contactEmail",
      ],
    },
    {
      title: "Appointments",
      properties: ["appointments"],
    },
  ],
  initialContent: {
    ...defaultPageInitialContent,
    title: "New Training Course",
    body: [new HeadlineWidget({ style: "h1" })],
  },
  validations: [
    [
      "startDate",
      (startDate, { obj }) => {
        const endDate = obj.get("endDate");
        if (startDate && endDate && startDate > endDate) {
          return "Start date must be before end date.";
        }
      },
    ],
    [
      "title",
      (title) =>
        (!title || title === "New Training Course") && "Title is required.",
    ],
    [
      "contactEmail",
      (contactEmail) => !contactEmail && "Registration E-Mail is required.",
    ],
  ],
});
